export enum THEME {
	Light = 'Light',
	Dark = 'Dark',
}
